import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';

interface ComingSoonProps {
  title?: string;
  description?: string;
}

export function ComingSoon({
  title = 'Próximamente',
  description = 'Esta funcionalidad estará disponible próximamente.'
}: ComingSoonProps) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="mx-auto h-24 w-24 text-secondary-400 dark:text-secondary-600 mb-6">
          <WrenchScrewdriverIcon className="h-full w-full" />
        </div>
        <h2 className="text-3xl font-bold text-secondary-900 dark:text-white mb-4">
          {title}
        </h2>
        <p className="text-lg text-secondary-600 dark:text-secondary-400 max-w-md mx-auto">
          {description}
        </p>
      </div>
    </div>
  );
}
